import clsx from 'clsx'
import type { ReactNode } from 'react'
import { statusTone, statusToneClasses, type StatusObject } from '@/lib/statusTone'

// docs/specs/DESIGN-SYSTEM.md §1b: a status is a SOFT pill — tint, coloured
// text, a leading 7px dot and its words. Never colour alone.

interface StatusPillProps {
  object: StatusObject
  status: string | null | undefined
  /** Override the words (e.g. a pallet shown as "Retipped"); the tone stays. */
  label?: string
  /** A small glyph after the dot (never instead of it). */
  icon?: ReactNode
  className?: string
}

export default function StatusPill({ object, status, label, icon, className }: StatusPillProps) {
  const { tone, label: words } = statusTone(object, status)
  const c = statusToneClasses(tone)
  return (
    <span
      data-tone={tone}
      className={clsx(
        'inline-flex items-center gap-1.5 rounded-full py-[3px] pl-2 pr-2.5 text-caption font-medium whitespace-nowrap',
        c.pill,
        className,
      )}
    >
      <span aria-hidden="true" className={clsx('h-[7px] w-[7px] shrink-0 rounded-full', c.dot)} />
      {icon}
      {label ?? words}
    </span>
  )
}
